<template>
  <div>
    <!-- TODO IMG SRC--->
    <v-img
      src="/bg.jpg"
      lazy-src="/bgload.jpg"
      aspect-ratio="2.5"
      max-height="500"
      gradient="180deg, rgba(0,222,111,0.19091386554621848) 55%, rgba(0,166,28,0.927608543417367) 90%"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="green lighten-2"
          ></v-progress-circular>
        </v-row>
      </template>
      <v-row align="end" justify="center" class="white--text pa-2 fill-height">
        <v-col
          class="mx-auto d-inline-block flex-grow-1"
          style="max-width: 1000px;"
        >
          <div class="display-2 text-uppercase font-weight-bold">
            Pysy&nbsp;kotona
            <div class="d-none d-sm-inline-block">- Kiuruvesi</div>
          </div>
          <div class="title">
            Tervetuloa asioimaan Kiuruvetisissä yrityksissä
          </div>
        </v-col>
      </v-row>
    </v-img>
    <v-row class="ma-0">
      <v-col cols="12">
        <LandingStrip>
          <Categories />
          <v-alert text color="orange"
            >Huomaa! Uudistimme sivustoja vastikään, joten jos jokin näyttää
            oudolta niin laita viestiä! Vanhoja sivuja pääsee selaamaan
            <a href="https://old.kotona.kiuruvesi.net">tästä</a>.</v-alert
          >
        </LandingStrip>
      </v-col>
      <v-col cols="12">
        <LandingStrip notop>
          <h3>
            Tue paikallisia yrittäjiä - Tältä sivulta löydät palveluita, jotka
            toimivat koronaviruksesta huolimatta. Sivustoa päivitetään
            jatkuvasti, joten vieraile uudelleenkin!
          </h3>
          <div class="caption">
            Tämän sivuston on tehnyt yksityishenkilö auttaakseen ihmisiä
            löytämään palveluita tässä poikkeustilassa. - Vili Tikkanen
            Kiuruvedellä 21.3.2020. <a href="/yhteys">Lue lisää sivustosta</a>
          </div>
        </LandingStrip>
      </v-col>
      <v-col cols="12">
        <LandingStrip notop>
          <Spotlight></Spotlight>
        </LandingStrip>
      </v-col>
      <v-col cols="12">
        <LandingStrip notop>
          <OpenToday></OpenToday>
        </LandingStrip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Categories from './components/Categories'
import LandingStrip from './components/part/LandingStrip'
import Spotlight from './components/Spotlight'
import OpenToday from './components/OpenToday'

export default {
  name: 'Frontpage',
  components: {
    Categories,
    LandingStrip,
    Spotlight,
    OpenToday
  }
}
</script>
